// How a data-connector registry record (backend: connectors/registry.py)
// reads to a founder. The one rule: "Connected" must never mean merely
// "a credential is stored". Only a real, authenticated provider read (a
// health check or a sync that actually succeeded -- the backend sets
// status HEALTHY only then) earns a verified/"good" state.

const SYNC_STALE_AFTER_MS = 10 * 60 * 1000;

export function connectionTruth(record, now = Date.now()) {
  const status = record?.status;
  const sync = record?.last_sync_status;

  if (!status || status === 'NOT_CONNECTED') {
    return { key: 'not_connected', label: 'Not connected', tone: 'neutral' };
  }
  if (status === 'DISCONNECTED' || status === 'CREDENTIAL_REVOKED') {
    return { key: 'disconnected', label: 'Disconnected', tone: 'neutral' };
  }
  if (status === 'SYNCING' || sync === 'SYNCING') {
    // A SYNCING marker that never resolved (e.g. the request died) must
    // not read as "syncing" forever.
    const updated = record?.updated_at ? Date.parse(record.updated_at) : NaN;
    if (Number.isNaN(updated) || now - updated < SYNC_STALE_AFTER_MS) {
      return { key: 'syncing', label: 'Syncing…', tone: 'neutral' };
    }
  }
  if (status === 'ACTION_REQUIRED') {
    return { key: 'needs_attention', label: 'Connected — needs attention', tone: 'warn' };
  }
  if (status === 'EXPIRED') {
    return { key: 'needs_attention', label: 'Expired — reconnect', tone: 'warn' };
  }
  if (status === 'ERROR') {
    return { key: 'unverified_error', label: "Couldn't verify", tone: 'bad' };
  }
  if (status === 'CONNECTED') {
    // Credentials obtained, nothing read from the provider yet.
    return { key: 'connected_unverified', label: 'Connected — not yet verified', tone: 'neutral' };
  }
  if (status === 'HEALTHY') {
    if (sync === 'FAILED') return { key: 'sync_failed', label: 'Connected — last sync failed', tone: 'warn' };
    if (sync === 'PARTIAL') return { key: 'sync_partial', label: 'Connected — last sync partial', tone: 'warn' };
    if (sync === 'SUCCESS') return { key: 'sync_successful', label: 'Connected — last sync successful', tone: 'good' };
    return { key: 'connected_verified', label: 'Connected — verified', tone: 'good' };
  }
  return { key: 'not_connected', label: 'Not connected', tone: 'neutral' };
}
